module.exports = __webpack_public_path__ + "static/media/5.b4a9ac95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/5.svg
// module id = 129
// module chunks = 0